import { ADS_API } from "@/utils/http"

export const getCpaCampaignOrders = ({ pageSize = 10, page = 1, query = {} } = {}) => {
  const paginationQuery = { limit: pageSize, offset: (page - 1) * pageSize }
  const params = { ...query, ...paginationQuery }

  return ADS_API.get(`/v1/backoffice/cpa-campaign/orders/`, { params })
}

export const getCpaCampaign = () => {
  return ADS_API.get(`/v1/backoffice/cpa-campaign/`)
}
